import {
  MAX_STROKE_WIDTH, MIN_STROKE_WIDTH, ABSOLUTE, RELATIVE,
  VALUE, RED, GRAY, GREEN, CONFIRMED, RECOVERED, DEATHS,
} from '../constants';

export default function calculateStrokeWidth(featuresObj, quality, param, period) {
  let copyFeatures;
  let maxCasesValue;
  const casesParam = period + param;
  if (quality === ABSOLUTE) {
    featuresObj.features.sort((a, b) => b.properties[casesParam] - a.properties[casesParam]);
    maxCasesValue = featuresObj.features[0].properties[casesParam];
    copyFeatures = featuresObj.features.map((feature) => {
      const { properties } = feature;
      const casesValue = properties[casesParam];
      let width = MIN_STROKE_WIDTH;
      if (casesValue > 0) {
        width = Math.floor((casesValue * MAX_STROKE_WIDTH) / maxCasesValue);
      }
      let color;
      if (param === RECOVERED) {
        color = GREEN;
      } else if (param === DEATHS) {
        color = GRAY;
      } else if (param === CONFIRMED) {
        color = RED;
      }
      const copyFeature = {
        ...feature,
        properties: {
          ...feature.properties,
          stroke: width,
          markerColor: color,
          currentPeriod: period,
          currentParam: param,
        },
      };
      return copyFeature;
    });
  }

  if (quality === RELATIVE) {
    featuresObj.features.sort((a, b) => {
      const valueB = b.properties[casesParam];
      const valueA = a.properties[casesParam];
      const resultB = (valueB * VALUE) / b.properties.population;
      const resultA = (valueA * VALUE) / a.properties.population;
      return resultB - resultA;
    });
    const antiRecord = featuresObj.features[0];
    maxCasesValue = (antiRecord.properties[casesParam] * VALUE) / antiRecord.properties.population;
    copyFeatures = featuresObj.features.map((feature) => {
      const { properties } = feature;
      const casesValue = (properties[casesParam] * VALUE) / properties.population;
      let width = MIN_STROKE_WIDTH;
      if (casesValue > 0) {
        width = Math.floor((casesValue * MAX_STROKE_WIDTH) / maxCasesValue);
      }
      let color;
      if (param === RECOVERED) {
        color = GREEN;
      } else if (param === DEATHS) {
        color = GRAY;
      } else if (param === CONFIRMED) {
        color = RED;
      }
      const copyFeature = {
        ...feature,
        properties: {
          ...feature.properties,
          stroke: width,
          markerColor: color,
          currentPeriod: period,
          currentParam: param,
        },
      };
      return copyFeature;
    });
  }
  const copyFeaturesObj = { ...featuresObj, features: copyFeatures };
  return copyFeaturesObj;
}
